import {Invoice,} from '../types';
import {Stack} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator
} from "@flexinet/ui-components";
import {StatusBadge} from "./StatusBadge.tsx";
import {CustomerLink} from "../links/CustomerLink.tsx";
import {PaymentStatusBadge} from "./PaymentStatusBadge.tsx";


export const Profile = ({record}: { record: Invoice }) => {

    const properties = [
        {
            label: 'Invoice ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Status',
            value: <StatusBadge status={record.status}/>,
            span: 6,
        }, {
            label: 'Paid',
            value: <PaymentStatusBadge status={record.paid}/>,
            span: 6,
        }, {
            label: 'Customer',
            value: <CustomerLink customer={record.customerId} customerName={record.customerName}
                                 customerEmail={record.customerEmail}/>,
            span: 12,
        }, {
            label: 'Collection Method',
            value: record.collectionMethod === 'send_invoice' ? 'Send Invoice' : 'Charge Automatically',
            span: 12,
        }, {
            label: 'Payment Terms',
            value: record.daysUntilDue > 0 ? `Net ${record.daysUntilDue}` : '-',
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
